import _defineProperty from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import Badge from '../badge';
import SafeArea from '../safe-area';
import { usePropsValue } from '../../utils/use-props-value';
import { traverseReactNode } from '../../utils/traverse-react-node';
/* istanbul ignore next */

export var TabBarItem = function TabBarItem() {
  return null;
};
var classPrefix = "adm-tab-bar";
var defaultProps = {
  safeArea: false
};
export var TabBar = function TabBar(p) {
  var _a;

  var props = mergeProps(defaultProps, p);
  var firstActiveKey = null;
  var items = [];
  traverseReactNode(props.children, function (child, index) {
    if (!React.isValidElement(child)) return;
    var key = child.key;
    if (typeof key !== 'string') return;

    if (index === 0) {
      firstActiveKey = key;
    }

    items.push(child);
  });

  var _usePropsValue = usePropsValue({
    value: props.activeKey,
    defaultValue: (_a = props.defaultActiveKey) !== null && _a !== void 0 ? _a : firstActiveKey,
    onChange: function onChange(v) {
      var _a;

      if (v === null) return;
      (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
    }
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      activeKey = _usePropsValue2[0],
      setActiveKey = _usePropsValue2[1];

  return withNativeProps(props, React.createElement("div", {
    className: classPrefix
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-wrap")
  }, items.map(function (item) {
    var active = item.key === activeKey;

    function renderContent() {
      var iconElement = item.props.icon && React.createElement("div", {
        className: "".concat(classPrefix, "-item-icon")
      }, typeof item.props.icon === 'function' ? item.props.icon(active) : item.props.icon);
      var titleElement = item.props.title && React.createElement("div", {
        className: classNames("".concat(classPrefix, "-item-title"), Boolean(iconElement) && "".concat(classPrefix, "-item-title-with-icon"))
      }, typeof item.props.title === 'function' ? item.props.title(active) : item.props.title);

      if (iconElement) {
        return React.createElement(React.Fragment, null, React.createElement(Badge, {
          content: item.props.badge,
          className: "".concat(classPrefix, "-icon-badge")
        }, iconElement), titleElement);
      } else if (titleElement) {
        return React.createElement(Badge, {
          content: item.props.badge,
          className: "".concat(classPrefix, "-title-badge")
        }, titleElement);
      }

      return null;
    }

    return withNativeProps(item.props, React.createElement("div", {
      key: item.key,
      onClick: function onClick() {
        var key = item.key;
        if (key === undefined || key === null) return;
        setActiveKey(key.toString());
      },
      className: classNames("".concat(classPrefix, "-item"), _defineProperty({}, "".concat(classPrefix, "-item-active"), active))
    }, renderContent()));
  })), props.safeArea && React.createElement(SafeArea, {
    position: 'bottom'
  })));
};